// Utility for triggering background health checks with cooldown

const lastCheckTimes = new Map<string, number>();

/**
 * Triggers a background health check for a station that experienced a playback error.
 * Includes a 60-second cooldown to prevent spam.
 * This is a fire-and-forget operation that doesn't wait for the response.
 *
 * @param stationId - The ID of the station
 * @param streamUrl - The stream URL to check
 */
export const triggerHealthCheck = async (
  stationId: string,
  streamUrl: string,
): Promise<void> => {
  const now = Date.now();
  const lastCheck = lastCheckTimes.get(stationId) || 0;

  // Cooldown: minimum 60 seconds between checks for the same station
  if (now - lastCheck < 60000) {
    console.log(
      `[HealthCheck] Skipping check for ${stationId} - cooldown active`,
    );
    return;
  }

  lastCheckTimes.set(stationId, now);

  try {
    // Fire and forget - don't wait for response
    fetch("/api/health/check", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ stationId, streamUrl }),
    }).catch((e) => console.warn("[HealthCheck] Failed:", e));

    console.log(`[HealthCheck] Triggered for ${stationId}`);
  } catch (e) {
    console.warn("[HealthCheck] Error triggering health check:", e);
  }
};
